/*!
 *  Sunway
 *  sunway.js
 *  Copyright 2014 Foursites
 *
 *  Author      : Foursites
 *  Version     : 1.0
 *
 */

define('sunway',['require','vendor/jquery.placeholder','libs/utilities.istouch','libs/carousel.custom','libs/components.carousel','libs/components.tellinks','libs/components-boundingclient','TweenLite','TimelineLite','libs/navigation','libs/viewportmanager','libs/smoothscroll','libs/searchform','libs/teaser.backgroundimage','libs/tabs','libs/gallery','libs/selectbox','libs/steelselector','libs/socialbutton','libs/dealerform','libs/digistudio.toolbar','libs/dealerlocator','libs/lazyloader','libs/utilities.element.getdimensions','libs/photogallery','libs/scrolltopbutton','libs/dialog.manager','libs/equalizer','libs/webfontloadcheck'],function(require) {

    'use strict';

    /**
     * Hier requiren we alle modules/files die we nodig hebben voor dit script.
     * require(pad/filename-zonder-extentie)
     * Basispad is nog steeds wat we in main.js gedefinieerd hebben.
     */
    var placeholder = require('vendor/jquery.placeholder'),
        istouch = require('libs/utilities.istouch'),
        Carousel = require('libs/carousel.custom'),
        carouselSlider = require('libs/components.carousel'),
        tel = require('libs/components.tellinks'),
        rect = require('libs/components-boundingclient'),
        TweenLite = require('TweenLite'),
        TimelineLite = require('TimelineLite'),

        Nav = require('libs/navigation'),
        ViewportManager = require('libs/viewportmanager'),
        Scroller = require('libs/smoothscroll'),
        SearchForm = require('libs/searchform'),
        BGImage = require('libs/teaser.backgroundimage'),
        Tabs = require('libs/tabs'),
        Gallery = require('libs/gallery'),
        SelectBox = require('libs/selectbox'),
        SteelSelector = require('libs/steelselector'),
        SocialButton = require('libs/socialbutton'),
        Dealerform = require('libs/dealerform'),
        Toolbar = require('libs/digistudio.toolbar'),
        DealerLocator = require('libs/dealerlocator'),
        LazyLoader = require('libs/lazyloader'),
        getDimensions = require('libs/utilities.element.getdimensions'),
        PhotoGallery = require('libs/photogallery'),
        ScrollTopBtn = require('libs/scrolltopbutton'),
        DialogManager = require('libs/dialog.manager'),
        Equalizer = require('libs/equalizer'),
        waitForWebfonts = require('libs/webfontloadcheck');


    // IE < 9
    //var OLD_BROWSER = !document.addEventListener;

    var SUNWAY = {

        version: 1.0,
        // Main settings...
        settings: {

        },

        // Main initialization...
        init: function() {
            this.initCarousel();
            this.initSlider();
            this.initVendors();
            this.initHomepage();
            this.initTeaserContent();

            this.initMobileNav();
            this.initViewport();
            this.initScroll();
            this.initContentAnimations();
            this.initSearchForm();
            this.initTeaserImage();
            this.initTabs();


            if ((document.documentElement || document.body).clientWidth > 760) {
                this.initGallery();
            }


            this.initEqualizer();
            this.initAccordion();

            this.initSocialButtons();
            this.initDealerForm();
            this.initToolbar();
            this.initCustomSelects();
            this.initDealerLocator();
            // this.initLazyLoader();
            this.initPhotoGallery();
            this.initScrollTopBtn();

            this.initTeaserScrollToSection();

            this.initAutoAddress();

            new DialogManager();

            $(window).on('load', function() {
                $(document.body).removeClass('loading');
            });
        },

        initEqualizer: function() {
            waitForWebfonts(['Montserrat'], function() {
                $('.product-carousel').each(function(i, el) {
                    new Equalizer(el, {selector: '.content'});
                });
            });
        },

        initAccordion: function() {
            var allPanels = $('.accordion-body').removeClass('in');

            $('.accordion-toggle').click(function() {
                $('.accordion-body').removeClass('in');
                $(this).parent().next().addClass('in');
                return false;
            });
        },

        initSlider: function() {
            $('.carousel').flexslider({
                namespace: 'carousel-',
                animation: 'slide',
                selector: '.carousel-images > li',
                slideshowSpeed: 7000,
                animationSpeed: 900,
                useCSS: true,
                pauseOnHover: true,
                touch: true,
                controlNav: false,
                directionNav: true
            });
        },

        initGallery: function() {
            var $body = $(document.body);


            var staticGallery = $('.inspire__album');
            if (staticGallery.length) {
                staticGallery.css('height', window.innerHeight);
                var imgList = $body.find('.inspire__media');
                var gallery = new Gallery(imgList, {
                    pictureSelector: '.inspire__item',
                    btnNextSelector: '.btn--next',
                    btnPrevSelector: '.btn--prev',
                    containerSelector: '.inspire',
                    indicator: '.inspire__counter'
                });
            }


            function openGallery(container, event) {
                event.preventDefault();
                // clone gallery.
                var wrapper = $('<div class="dialog-gallery"/>'),
                    clone = $(container[0].cloneNode(true)),
                    imgList = clone.find('.inspiration-media'),
                    overlay = $('<div class="gallery-overlay"/>'),
                    btnClose = $('<span class="btn-close icon-close"/>');
                // insert in the page.
                wrapper.append(clone);
                imgList.parent().append(btnClose);
                $body.append(wrapper);
                $body.append(overlay);

                if ((document.documentElement || document.body).clientWidth <= 400) {
                    imgList.css('height', '');
                }

                // center the dialog vertically.
                wrapper.css('top', ((document.documentElement || document.body).clientHeight - imgList.height()) / 2);
                wrapper.css('left', ((document.documentElement || document.body).clientWidth - imgList.width()) / 2);

                // initialize the gallery.
                var gallery = new Gallery(imgList);

                // add the active classes to trigger the css transitions.
                setTimeout(function() {
                    wrapper.addClass('dialog-active');
                    overlay.addClass('active');

                    if ((document.documentElement || document.body).clientWidth <= 760) {
                        var dialogWidth = $('.dialog-gallery.dialog-active .inspiration-media').width();
                        var dialogCount = $('.dialog-gallery.dialog-active .inspiration-media li').length;

                        $('.dialog-gallery.dialog-active .inspiration-media li').css({
                            width: dialogWidth / dialogCount
                        });
                    }
                }, 10);

                var closeFunction = closeGallery.bind(this, overlay, wrapper, gallery);
                overlay.on('click', closeFunction);
                btnClose.on('click', closeFunction);
            }

            function closeGallery(overlay, wrapper, gallery) {
                // remove any keyboard listeners.
                gallery.stopKeyboardListener();

                // remove the active classes to trigger the css transitions.
                overlay.removeClass('active');
                wrapper.removeClass('dialog-active');

                // after the transitions, remove from the page.
                setTimeout(function() {
                    overlay.remove();
                    wrapper.remove();
                }, 700);
            }

            function setGalleryHeight(containers) {
                var viewportWidth = $(window).width();
                containers.each(function() {
                    var container = $(this);
                    var containerContent = $(this).nextAll('.content');
                    container.css('height', '');
                    requestAnimationFrame(function() {
                        container.css('height', getDimensions(container[0]).width / 2 - 100);

                        if ((viewportWidth >= 760)) {
                            containerContent.css('height', getDimensions(container[0]).width / 2 -100);
                        }
                    });
                });
            }
            // set height to grid so height percentages work.
            if ((document.documentElement || document.body).clientWidth >= 990) {

                var galleryContainers = $('.inspiration-media');
                $(window).on('resize', setGalleryHeight.bind(this, galleryContainers));
                $body.on('tab.active', setGalleryHeight.bind(this, galleryContainers));



                setGalleryHeight(galleryContainers);
            }

            $('.inspiration').each(function() {
                var container = $(this),
                    buttons = container.find('.btn-left, .btn-right');

                buttons.on('click', openGallery.bind(this, container));
            });
        },

        initTeaserImage: function() {
            if ($('body').hasClass('page-homepage')) {

                var imageIpad = $('.teaser__background');
                var imageBlur = $('.teaser__background-highres');
                var ipad = $('.teaser .ipad-screen');

                var heroImage = $('.hero__image');

                if (imageIpad.length) {
                    new BGImage(imageIpad);
                    new BGImage(ipad);
                    new BGImage(imageBlur);
                }

                if (heroImage.length) {
                    heroImage.each(function() {
                        new BGImage($(this));
                    })
                }
            } else {
                var teaser = $('.teaser');

                if (teaser.length) {
                    new BGImage(teaser);
                }
            }

            //productoverview
            if (!$('body').hasClass('page-homepage')) {
                var viewportHeight = $(window).height();
                $('.productoverview').css({
                   height: viewportHeight
                });
            }
        },

        initTabs: function() {
            var tabs = $('.collection-tabs');
            if (tabs.length) {
                new Tabs(tabs);
            }
        },

        initSearchForm: function() {
            new SearchForm();
        },

        initContentAnimations: function() {
            // fade in the elements one by one.
            function getAnimatedNodes() {
                var toAnimate = $('.animate-content');
                // put in the correct order.
                toAnimate.sort(function(a, b) {
                    var first = a.getAttribute('data-sequence'),
                        second = b.getAttribute('data-sequence');

                    if (first == second)
                        return 0;
                    if (first < second)
                        return -1;
                    else
                        return 1;
                });

                return toAnimate;
            }

            //create the timeline.
            var timeline = new TimelineLite({
                delay: .5,
                paused: true
            });

            var nodes = getAnimatedNodes();

            nodes.each(function(i, node) {
                var time = Number(this.getAttribute('data-time')) || 1;
                timeline.add(TweenLite.fromTo(this, time, {
                    opacity: 0,
                    onComplete: function() {
                        $(node).removeClass('animate-content');
                    }
                }, {opacity: 1}), i * .5);
            });

            // start fading in the elements after a delay.
            timeline.play();
        },

        initLightWidget: function() {
            var sunlightWidgetRoot = $('.sunlight-tool');
            if (sunlightWidgetRoot.length) {
                new LightWidget(sunlightWidgetRoot[0]);
            }
        },

        initScroll: function() {
            new Scroller(document, {
                verticalOnly: true,
                minDuration: .5,
                maxDuration: 1.5
            });
        },

        initMobileNav: function() {
            new Nav();
        },

        initCustomSelects: function() {
            var touch = istouch(),
            onchange = function() {
                var url = this.options[this.selectedIndex].getAttribute('data-url');
                if (url) {
                    window.location = url;
                }
            };

            $('select.custom').each(function() {
                if (!touch) {
                    new SelectBox(this);
                } else {
                    //redirect the page on change.
                    $(this).on('change', onchange);
                }
            });
        },

        initDigiStudioSelect: function() {
            $('select[name=digistudio]').each(function() {
                new DigistudioSelect(this);
            });


            $('#dialog-all-categories a').on('click', function(event) {
                event.preventDefault();
                var prodId = $(event.currentTarget).data('prod-id');
                if (prodId) {
                    DigistudioSelect.prototype.onSelect(event, prodId);
                }
            });
        },

        initSteels: function() {
            $('.all-steels').each(function() {
                new SteelSelector(this);
            });
        },

        initSocialButtons: function() {
            /** Social buttons **/
            var btns = $('.social-link');
            btns.each(function() {
                new SocialButton(this, this.getAttribute('data-service'));
            });

            $('.link-print').click(function(event) {
                event.preventDefault();

                window.print();
            });
        },

        initDealerForm: function() {
            var form = $('.dealer-form');
            if (form.length) {
                new Dealerform(form[0]);
            }
        },

        initToolbar: function() {
            var toolbar = $('.digistudio-toolbar .toolbars');
            if (toolbar.length) {
                new Toolbar(toolbar);
            }
        },

        initDealerLocator: function() {
            var root_map = document.getElementById('dealer-map'),
                root_content = $('.dealer-locator');
            if (root_map && root_content.length) {
                new DealerLocator(root_content, {});
            }

            var viewportWidth = $(window).width();
            if ((viewportWidth >= 760)) {
                var windowHeight = $(window).height();
                $('#dealer-map').css({
                    height: windowHeight
                });
            }
        },

        initLazyLoader: function() {
            $.fn.scrollStopped = function(callback) {
                var $this = $(this), self = this;
                $this.scroll(function(){
                    if ($this.data('scrollTimeout')) {
                      clearTimeout($this.data('scrollTimeout'));
                    }
                    $this.data('scrollTimeout', setTimeout(callback,250,self));
                });
            };

            var count = parseInt( fs_obj.posts_per_page, 10 );
            $(window).scrollStopped( function(){

                var winST = $(window).scrollTop(),
                    diff = ( $(document).height() - $(window).height() - 250 );

                if  ( winST >= diff ){
                    loadArticles( count );
                    count += parseInt( fs_obj.posts_per_page, 10 );
                }
            });

            function loadArticles(pageNumber) {
                $('.lazyloading').fadeIn(250);
                $.ajax({
                    url: fs_obj.ajaxurl,
                    type:'POST',
                    data: {
                        action: 'infinite_scroll',
                        page_id: fs_obj.page_id,
                        page_no: pageNumber
                    },
                    success: function(html){
                        $('.lazyloading').fadeOut(250);
                        if ( html !== '0' ) {
                            $('.content-container').append(html);
                        } else {
                            $('.lazyloading').remove();
                        }
                    }
                });
                return false;
            }
        },

        initPhotoGallery: function() {
            var imageAlbum = $('.inspire__image');

            if (imageAlbum.length) {
                imageAlbum.each(function() {
                    new BGImage($(this));
                });
            }

            if ((document.documentElement || document.body).clientWidth >= 760) {
                var windowHeight = $(window).height();
                $('.inspire').css({
                    height: windowHeight
                });
            }

            setTimeout(function() {
                if ((document.documentElement || document.body).clientWidth >= 760) {
                    $('.photogallery.set-height .inspiration-media').css({
                        height: '100%'
                    });
                }

                var root = $('.photogallery');
                if (root.length) {
                    new PhotoGallery(root);
                }
            },100);
        },

        initVendors: function() {
            $(window).resize(function() {
                //causeRepaintsOn.css("z-index", 1);
                $('body').css('z-index', 1);
            });
            $('input, textarea').placeholder();
            this.setGravPlaceholders();

            $('.footer .bar .gform_footer .button').on('click', function() {
                window.location.hash = 'gform_wrapper_1';
            });
        },

        setGravPlaceholders: function() {
            if (!$('html').hasClass('lte-ie9')) {
                $('.ginput_container input, .ginput_container textarea').each(function() {
                    var labeltext = $(this).parent().parent().find('label').text();//.replace(/ /g, '');
                    $(this).attr('placeholder', labeltext);
                });
            }

            // if ($('html').hasClass('lte-ie9')) {
            //     $('.ginput_container input, .ginput_container textarea').each(function() {
            //         var labeltext = $(this).parent().parent().find('label').text();//.replace(/ /g, '');
            //         $(this).attr('value', labeltext);
            //     });
            // }
        },

        // handle changes in viewport size.
        initViewport: function() {
            new ViewportManager();
        },

        initCarousel: function() {
            var root = $('.product-carousel');
            root.each(function() {
               new Carousel(this, {
                   touch: istouch(),
                   handleResize: true,
                   keyboardControl: true
               });
            });
        },

        initScrollTopBtn: function() {
            var btnTop = $('.btn-top');
            if (btnTop.length) {
                new ScrollTopBtn(btnTop[0]);
            }
        },

        // setGravPlaceholders: function() {
        //     if (!$('html').hasClass('lt-ie9')) {
        //         $('.ginput_container input, .ginput_container textarea').each(function() {
        //             var labeltext = $(this).parent().parent().find('label').text().replace(/ /g, '');
        //             $(this).attr('placeholder', labeltext);
        //         });
        //     }
        // },
        // initVendors: function() {
        //    $('input, textarea').placeholder();
        //    this.setGravPlaceholders();
        // },

        initHomepage: function() {
            var viewportWidth = $(window).width();
            if ((viewportWidth >= 950)) {
                var windowHeight = $(window).height();
                $('.teaser').css({
                    height: windowHeight
                });
                $('.teaser-background').css({
                    height: windowHeight
                });

            }
            if ((viewportWidth <= 760)) {
                var windowHeight = $(window).height();
                $('.teaser').css({
                    height: windowHeight
                });
                $('.teaser-background').css({
                    height: windowHeight
                });
                $('.teaser-background-highres').css({
                    height: windowHeight
                });
            }
            if ((viewportWidth >= 760)) {
                windowHeight = $(window).height();
                $('.digistudio').css({
                    height: windowHeight
                });

                $('.teaser-news').css({
                    height: windowHeight
                });

                var sunlightHeight = $('.hero .hero__top').outerHeight();
                $('.hero .hero__content').css({
                    height: windowHeight - sunlightHeight
                });
            }

            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)){
                $('body').addClass('touch-device');
            }
        },

        initTeaserContent: function() {
            var viewportWidth = $(window).width();
           // if ((viewportWidth >= 970)) {
                var windowHeight = $('.teaser').height();
                var containerHeight = windowHeight - 270;

                if ($('body').hasClass('page-homepage')) {
                   containerHeight = windowHeight;
                }

                $('.teaser .container').css({
                    height: containerHeight
                });

                var teaserHeight = $('.teaser .teaser__article').height() / 2;
                $('.teaser .teaser__article').css('marginTop', -teaserHeight);
           // }

            if ((viewportWidth >= 760)) {
                setTimeout(function() {
                    if ($('body').hasClass('page-sidebar')) {
                        var contentContainerHeight = $('.content-container').outerHeight();
                        $('.aside').css({
                            height: contentContainerHeight
                        });
                    }
                },500);
            }
        },

        initTeaserScrollToSection: function() {

            function scrollPrev(e) {
                // e.preventDefault();
                isAnimating = true;
                var from = $(document).scrollTop(), dist = -Infinity, to;
                $.each( positions, function( name, pos ) {
                    var myDist = Math.floor(pos) - from;
                    if ( myDist < 0 && myDist > dist ) {
                        dist = myDist;
                        to = pos;
                    }
                });

                $('html, body').stop(true).animate( { scrollTop: to }, 500, function(){ isAnimating = false; } );
                return false;
            }

            function scrollNext(e) {
                // e.preventDefault();
                isAnimating = true;
                var from = $(document).scrollTop(), dist = Infinity, to;
                $.each( positions, function( name, pos ) {
                    var myDist = Math.floor(pos) - from;
                    if ( myDist > 0 && myDist < dist ) {
                        dist = myDist;
                        to = pos;
                    }
                });
                $('html, body').stop(true).animate( { scrollTop: to }, 500, function(){ isAnimating = false; }  );
                return false;
            }


            if ($('body').hasClass('page-homepage')) {

                var isAnimating = false;
                var positions = {};
                $('.scrollsection').each(function(){ positions[this.id] = $( '#' + this.id ).offset().top; });



                var isMobile = {
                    Android: function() {
                        return navigator.userAgent.match(/Android/i);
                    },
                    BlackBerry: function() {
                        return navigator.userAgent.match(/BlackBerry/i);
                    },
                    iOS: function() {
                        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                    },
                    Opera: function() {
                        return navigator.userAgent.match(/Opera Mini/i);
                    },
                    Windows: function() {
                        return navigator.userAgent.match(/IEMobile/i);
                    },
                    any: function() {
                        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                    }
                };

                if(isMobile.any()){
                    // Mobile!
                } else {
                    $('.teaser').on( 'DOMMouseScroll mousewheel', function( e ){
                        e.preventDefault();
                        var e = window.event || e; // old IE support
                        var delta = Math.max( -1, Math.min( 1, ( e.wheelDelta || -e.originalEvent.detail ) ) );
                        if ( delta < 0 ) {
                            if( ! isAnimating ) { scrollNext(); }
                        } else {
                            if ( delta > 0 ) {
                                if( ! isAnimating ) { scrollPrev(); }
                            }
                        }
                        return false;
                    });
                }
            }
        },

        initAutoAddress: function() {

            function isValidPostcode(str) {
                if (!str.match(/^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i)) {
                    return false;
                } else {
                    return true;
                }
            }

            if (!$('body').hasClass('lte-ie9')) {

                $.ajaxSetup({
                    beforeSend : function(xhr) {
                        xhr.setRequestHeader( 'X-Api-Key', 'Jfi2qFZbrd6Q9YWFWDokJ4OwW9rHYqHG1gNO6YmE' );
                        xhr.setRequestHeader( 'X-Api-Key', 'Jfi2qFZbrd6Q9YWFWDokJ4OwW9rHYqHG1gNO6YmE' );
                    }
                });

                $('.gform_wrapper .disabled input').attr( 'readonly', '' );

                $('.postcode-field input, .number-field input').on('blur', function() {

                    var contentType = 'application/x-www-form-urlencoded; charset=utf-8';

                    if(window.XDomainRequest) //for IE8,IE9
                        contentType = 'text/plain';

                    var postcode = $('.postcode-field input').val(),
                        number, url;

                    if (postcode && isValidPostcode(postcode)) {

                        postcode = postcode.replace(/\s/g, '');
                        url = 'https://postcode-api.apiwise.nl/v2/addresses';
                        number = $('.number-field input').val();

                        // console.log('lets go!');

                        $.ajax({
                            url: url,
                            data: {
                                postcode: postcode,
                                number: number,
                            },
                            headers: { 'X-Api-Key': 'Jfi2qFZbrd6Q9YWFWDokJ4OwW9rHYqHG1gNO6YmE' },
                            beforeSend: function( obj, settings ) {
                                // console.log( settings.url );
                            },
                            success: function(data, status, obj) {
                                var address = data._embedded.addresses[0].street;
                                var city = data._embedded.addresses[0].city.label;
                                $('.address-field input').val(address + ' ' + number);
                                $('.city-field input').val(city);
                            },
                            error: function(obj, status, error) {
                                console.dir( obj.getAllResponseHeaders() );
                                //console.log( status );
                                //console.log( error );
                                alert('Voer een geldige postcode en huisnummer in');
                                // $('.address-field input').val('');
                                // $('.city-field input').val('');
                            }
                        });
                    }
                });
            }
        },

        initProductOptions: function() {

            $( '.dealer-form' ).delegate( 'select#product', 'change', function(e){

                var product_id = $(this).val();
                var form_list = $(this).parents('.product-selector');
                var models_select = form_list.find('#model');
                var controls_select = form_list.find('#control');

                form_list.animate(
                    { opacity: 0.5 },
                    250, function() {
                        form_list.find( ':input' ).prop( 'disabled', true );
                        $.ajax({
                            url: fs_obj.ajaxurl,
                            type:'POST',
                            data: {
                                action: 'get_product_options',
                                product_id: product_id
                            },
                            success: function( html ) {
                                var obj = $.parseJSON( html );
                                models_select.empty().append( obj.models_html );
                                controls_select.empty().append( obj.controls_html );
                                form_list.animate({opacity: 1}, 250);
                                form_list.find( ':input' ).prop( 'disabled', false );
                            }
                        });
                    }
                );
            });

        }
    };


    /**
     * return het SUNWAY object.
     * Als we deze file requieren (bij ons nu in main.js) krijgen we dit object als parameter binnen, zie main.js.
     */
    return SUNWAY;
});

